// extracted by mini-css-extract-plugin
module.exports = {"page-footer":"qmQMJejwe-UANWteGBAIh","pageFooter":"qmQMJejwe-UANWteGBAIh"};